var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CartLogin',{attrs:{"user":_vm.user,"error":_vm.loginError}}),_c('CartAddress',{attrs:{"user":_vm.user}}),_c('CartPaymentMethods',{attrs:{"paymentOptions":_vm.paymentOptions,"selectedPayment":_vm.$parent.selectedPayment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }